// Simple light cache for any type of assets with a limit on number of items stored.
export const createInMemoryCache = <T>(cacheLimit: number) => {
    const cache = new Map<string, T>();

    return {
        get(key: string): T | undefined {
            if (!cache.has(key)) {
                return undefined;
            }

            const data = cache.get(key);
            // Move to end to mark as recently used
            cache.delete(key);
            cache.set(key, data);

            return data;
        },
        set(key: string, data: T): void {
            if (cache.has(key)) {
                cache.delete(key);
            }

            cache.set(key, data);

            if (cache.size > cacheLimit) {
                const oldestKey = cache.keys().next().value;
                cache.delete(oldestKey);
            }
        },
        clear(): void {
            cache.clear();
        },
    };
};
